module.exports = __webpack_public_path__ + "public/img/qiandao.3189bf60.png";